var exports = {
  "N1": "ChannelHeader.module__headerContainer___UVZna0",
  "dL": "ChannelHeader.module__headerWrapper___UVZna0",
  "Hv": "ChannelHeader.module__headerWrapperCallActive___UVZna0",
  "hE": "ChannelHeader.module__headerContainerCallActive___UVZna0",
  "Pf": "ChannelHeader.module__callBannerRing___UVZna0",
  "Ud": "ChannelHeader.module__headerLeftSection___UVZna0",
  "Gv": "ChannelHeader.module__backButton___UVZna0",
  "wK": "ChannelHeader.module__backButtonDesktop___UVZna0" + " " + "ChannelHeader.module__backButton___UVZna0",
  "j2": "ChannelHeader.module__backIcon___UVZna0",
  "Ir": "ChannelHeader.module__backIconBold___UVZna0" + " " + "ChannelHeader.module__backIcon___UVZna0",
  "CY": "ChannelHeader.module__leftContentContainer___UVZna0",
  "Bn": "ChannelHeader.module__voiceCallHeaderSupplement___UVZna0",
  "BN": "ChannelHeader.module__mobileButton___UVZna0",
  "Vt": "ChannelHeader.module__desktopButton___UVZna0" + " " + "ChannelHeader.module__mobileButton___UVZna0",
  "R3": "ChannelHeader.module__avatarWrapper___UVZna0",
  "ax": "ChannelHeader.module__groupDmHeaderTrigger___UVZna0",
  "_D": "ChannelHeader.module__groupDmHeaderInner___UVZna0",
  "ab": "ChannelHeader.module__groupDmEditIcon___UVZna0",
  "HA": "ChannelHeader.module__channelName___UVZna0",
  "$7": "ChannelHeader.module__groupDmChannelName___UVZna0",
  "kf": "ChannelHeader.module__dmNameWrapper___UVZna0",
  "a1": "ChannelHeader.module__userTag___UVZna0",
  "p": "ChannelHeader.module__channelIcon___UVZna0",
  "ml": "ChannelHeader.module__caretRight___UVZna0",
  "Nj": "ChannelHeader.module__channelInfoContainer___UVZna0",
  "u8": "ChannelHeader.module__followButton___UVZna0",
  "B6": "ChannelHeader.module__topicDivider___UVZna0",
  "zm": "ChannelHeader.module__topicContainer___UVZna0",
  "yu": "ChannelHeader.module__topicButton___UVZna0",
  "Am": "ChannelHeader.module__topicButtonOverflow___UVZna0",
  "lY": "ChannelHeader.module__headerRightSection___UVZna0",
  "P0": "ChannelHeader.module__messageSearchFocusWrapper___UVZna0",
  "bS": "ChannelHeader.module__headerContainerThreadPanelOpen___UVZna0",
  "gb": "ChannelHeader.module__iconButton___UVZna0",
  "f5": "ChannelHeader.module__iconButtonDefault___UVZna0" + " " + "ChannelHeader.module__iconButton___UVZna0",
  "vR": "ChannelHeader.module__iconButtonSelected___UVZna0" + " " + "ChannelHeader.module__iconButton___UVZna0",
  "rB": "ChannelHeader.module__updateIconButton___UVZna0" + " " + "ChannelHeader.module__iconButton___UVZna0",
  "t4": "ChannelHeader.module__updateIconButtonDisabled___UVZna0" + " " + "ChannelHeader.module__updateIconButton___UVZna0" + " " + "ChannelHeader.module__iconButton___UVZna0",
  "l_": "ChannelHeader.module__updateIcon___UVZna0",
  "DW": "ChannelHeader.module__updateProgress___UVZna0",
  "IC": "ChannelHeader.module__iconButtonMobile___UVZna0",
  "iA": "ChannelHeader.module__buttonIcon___UVZna0",
  "qt": "ChannelHeader.module__buttonIconMobile___UVZna0",
  "Dm": "ChannelHeader.module__iconButtonWrapper___UVZna0",
  "W9": "ChannelHeader.module__unreadPinIndicator___UVZna0",
};

module.exports = exports;
